import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-56ade1b4")

_pushScopeId("data-v-56ade1b4")
const _hoisted_1 = /*#__PURE__*/_createVNode("p", { class: "fill-my-calendar-intro text-muted fs-8 mb-2" }, " One draft reel per day on your Calendar for the next 7, 14, or 30 days, starting tomorrow. Review or edit on the Calendar, publish when you want, or use auto-publish below for drafts you leave unchanged. ", -1)
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "social-post-page__label mb-2" }, "How many days", -1)
const _hoisted_4 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { class: "social-post-page__label mb-2" }, "Topic", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { class: "social-post-page__label mb-2" }, "Post time", -1)
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "social-post-page__label mb-2" }, "Language", -1)
const _hoisted_9 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_10 = { class: "social-post-page__radio-option" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "English", -1)
const _hoisted_12 = { class: "social-post-page__radio-option" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "Filipino", -1)
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", { class: "social-post-page__label mb-2" }, "Post to", -1)
const _hoisted_16 = {
  key: 0,
  class: "text-muted fs-8 mb-0"
}
const _hoisted_17 = { class: "d-inline-flex align-items-center gap-2" }
const _hoisted_18 = { class: "text-muted fs-8" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "social-post-page__label mb-0" }, "Voice", -1)
const _hoisted_20 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "social-post-page__label mb-0" }, "Tone", -1)
const _hoisted_22 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_23 = { class: "social-post-page__reel-options mb-3" }
const _hoisted_24 = { class: "social-post-page__reel-tone-body" }
const _hoisted_25 = { class: "social-post-page__reel-tone-title" }
const _hoisted_26 = { class: "social-post-page__reel-tone-description" }
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "social-post-page__label mb-0" }, "Background music", -1)
const _hoisted_28 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_29 = { class: "social-post-page__reel-options mb-3" }
const _hoisted_30 = { class: "social-post-page__reel-tone-option" }
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "social-post-page__reel-tone-body" }, [
  /*#__PURE__*/_createVNode("span", { class: "social-post-page__reel-tone-title" }, "No music")
], -1)
const _hoisted_32 = { class: "social-post-page__reel-tone-body" }
const _hoisted_33 = { class: "social-post-page__reel-tone-title" }
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "social-post-page__label mb-0" }, "Caption look", -1)
const _hoisted_35 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_36 = { class: "social-post-page__caption-style mb-3" }
const _hoisted_37 = /*#__PURE__*/_createVNode("p", { class: "text-muted fs-8 mb-2" }, " Choose how on-screen captions appear in your reel. Timing follows your voiceover. ", -1)
const _hoisted_38 = { class: "social-post-page__caption-preview-stage mb-3" }
const _hoisted_39 = { class: "social-post-page__caption-swatches mb-3" }
const _hoisted_40 = /*#__PURE__*/_createVNode("span", null, "Aa", -1)
const _hoisted_41 = { class: "social-post-page__caption-swatch-label" }
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "social-post-page__label mb-2" }, "Size", -1)
const _hoisted_43 = { class: "d-flex flex-wrap gap-3 mb-2" }
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "social-post-page__label mb-2" }, "Position", -1)
const _hoisted_45 = { class: "d-flex flex-wrap gap-3 mb-2" }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "social-post-page__label mb-2" }, "Casing", -1)
const _hoisted_47 = { class: "d-flex flex-wrap gap-3 mb-2" }
const _hoisted_48 = { class: "mb-3 mt-2" }
const _hoisted_49 = { class: "social-post-page__radio-option align-items-start" }
const _hoisted_50 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("span", { class: "fw-semibold d-block" }, "Auto-publish if I don't edit"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fs-8 d-block mt-1" }, " Editing a draft turns off auto-publish for that day. Video generation uses AI credits; the live post may appear a few minutes after the scheduled time. ")
], -1)
const _hoisted_51 = {
  key: 0,
  class: "text-danger fs-8 mt-2 mb-0"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SocialAccountAvatar = _resolveComponent("SocialAccountAvatar")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_ReelVoicePicker = _resolveComponent("ReelVoicePicker")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.visible = $event)),
    title: "Fill my calendar",
    class: "fill-my-calendar-dialog",
    width: "520px",
    "destroy-on-close": "",
    onClosed: _ctx.onClosed
  }, {
    footer: _withId(() => [
      _createVNode("button", {
        type: "button",
        class: "btn btn-light",
        disabled: _ctx.submitting,
        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.visible = false))
      }, " Cancel ", 8, ["disabled"]),
      _createVNode("button", {
        type: "button",
        class: "btn btn-primary",
        disabled: _ctx.submitting,
        onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      }, _toDisplayString(_ctx.submitting ? "Starting…" : "Start"), 9, ["disabled"])
    ]),
    default: _withId(() => [
      _hoisted_1,
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.durationOptions, (option) => {
            return (_openBlock(), _createBlock("button", {
              key: option,
              type: "button",
              class: ["btn btn-sm", _ctx.durationDays === option ? 'btn-primary' : 'btn-light'],
              disabled: _ctx.submitting,
              onClick: ($event: any) => (_ctx.durationDays = option)
            }, _toDisplayString(option) + " days ", 11, ["disabled", "onClick"]))
          }), 128))
        ])
      ]),
      _hoisted_5,
      _withDirectives(_createVNode("textarea", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.topic = $event)),
        class: "form-control mb-3",
        rows: "3",
        disabled: _ctx.submitting,
        placeholder: "Daily nutrition support for a busy routine"
      }, null, 8, ["disabled"]), [
        [_vModelText, _ctx.topic]
      ]),
      _hoisted_6,
      _withDirectives(_createVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.postTimeLocal = $event)),
        type: "time",
        class: "form-control mb-3",
        disabled: _ctx.submitting
      }, null, 8, ["disabled"]), [
        [_vModelText, _ctx.postTimeLocal]
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode("div", _hoisted_9, [
          _createVNode("label", _hoisted_10, [
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.languageCode = $event)),
              type: "radio",
              name: "fillLanguage",
              value: "en",
              disabled: _ctx.submitting
            }, null, 8, ["disabled"]), [
              [_vModelRadio, _ctx.languageCode]
            ]),
            _hoisted_11
          ]),
          _createVNode("label", _hoisted_12, [
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.languageCode = $event)),
              type: "radio",
              name: "fillLanguage",
              value: "fil",
              disabled: _ctx.submitting
            }, null, 8, ["disabled"]), [
              [_vModelRadio, _ctx.languageCode]
            ]),
            _hoisted_13
          ])
        ])
      ]),
      _createVNode("div", _hoisted_14, [
        _hoisted_15,
        (!_ctx.connectedAccounts.length)
          ? (_openBlock(), _createBlock("p", _hoisted_16, " Connect a social account first. "))
          : (_openBlock(), _createBlock(_component_el_select, {
              key: 1,
              modelValue: _ctx.selectedAccountKeys,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedAccountKeys = $event)),
              multiple: "",
              filterable: "",
              "collapse-tags": "",
              "collapse-tags-tooltip": "",
              placeholder: "Select a social account",
              class: "w-100",
              disabled: _ctx.submitting,
              onChange: _ctx.onAccountsChange
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.connectedAccounts, (account) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: _ctx.accountOptionKey(account),
                    label: _ctx.accountDisplayName(account),
                    value: _ctx.accountOptionKey(account)
                  }, {
                    default: _withId(() => [
                      _createVNode("span", _hoisted_17, [
                        _createVNode(_component_SocialAccountAvatar, {
                          avatar: account.avatar,
                          name: account.accountName,
                          "fallback-id": account.accountId,
                          "size-px": 28
                        }, null, 8, ["avatar", "name", "fallback-id"]),
                        _createVNode("i", {
                          class: _ctx.getPlatformMeta(account.platform).icon,
                          style: { color: _ctx.getPlatformMeta(account.platform).color }
                        }, null, 6),
                        _createVNode("span", null, _toDisplayString(_ctx.accountDisplayName(account)), 1),
                        _createVNode("span", _hoisted_18, "(" + _toDisplayString(_ctx.getPlatformMeta(account.platform).label) + ")", 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled", "onChange"]))
      ]),
      _createVNode("button", {
        type: "button",
        class: "social-post-page__reel-section-header mb-2 w-100",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.voiceExpanded = !_ctx.voiceExpanded))
      }, [
        _hoisted_19,
        (!_ctx.voiceExpanded)
          ? (_openBlock(), _createBlock("span", _hoisted_20, "· " + _toDisplayString(_ctx.selectedVoiceLabel), 1))
          : _createCommentVNode("", true),
        _createVNode("i", {
          class: ["fas ms-auto", _ctx.voiceExpanded ? 'fa-chevron-up' : 'fa-chevron-down']
        }, null, 2)
      ]),
      _withDirectives(_createVNode(_component_ReelVoicePicker, {
        voices: _ctx.filteredVoices,
        "model-value": _ctx.voiceId,
        expanded: _ctx.voiceExpanded,
        disabled: _ctx.submitting,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.voiceId = $event)),
        onPreview: _ctx.playVoicePreview
      }, null, 8, ["voices", "model-value", "expanded", "disabled", "onPreview"]), [
        [_vShow, _ctx.voiceExpanded]
      ]),
      _createVNode("button", {
        type: "button",
        class: "social-post-page__reel-section-header mb-2 w-100",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toneExpanded = !_ctx.toneExpanded))
      }, [
        _hoisted_21,
        (!_ctx.toneExpanded)
          ? (_openBlock(), _createBlock("span", _hoisted_22, "· " + _toDisplayString(_ctx.selectedToneLabel), 1))
          : _createCommentVNode("", true),
        _createVNode("i", {
          class: ["fas ms-auto", _ctx.toneExpanded ? 'fa-chevron-up' : 'fa-chevron-down']
        }, null, 2)
      ]),
      _withDirectives(_createVNode("div", _hoisted_23, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reelTones, (tone) => {
          return (_openBlock(), _createBlock("label", {
            key: tone.id,
            class: "social-post-page__reel-tone-option"
          }, [
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.toneId = $event)),
              type: "radio",
              name: "fillTone",
              value: tone.id,
              disabled: _ctx.submitting
            }, null, 8, ["value", "disabled"]), [
              [_vModelRadio, _ctx.toneId]
            ]),
            _createVNode("span", _hoisted_24, [
              _createVNode("span", _hoisted_25, [
                _createVNode("span", null, _toDisplayString(tone.label), 1),
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-link btn-sm p-0 ms-2 align-baseline",
                  disabled: !_ctx.voices.length || _ctx.submitting,
                  onClick: _withModifiers(($event: any) => (_ctx.playVoicePreview(null, tone.id)), ["stop","prevent"])
                }, " Preview ", 8, ["disabled", "onClick"])
              ]),
              _createVNode("span", _hoisted_26, _toDisplayString(tone.description), 1)
            ])
          ]))
        }), 128))
      ], 512), [
        [_vShow, _ctx.toneExpanded]
      ]),
      _createVNode("button", {
        type: "button",
        class: "social-post-page__reel-section-header mb-2 w-100",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.musicExpanded = !_ctx.musicExpanded))
      }, [
        _hoisted_27,
        (!_ctx.musicExpanded)
          ? (_openBlock(), _createBlock("span", _hoisted_28, "· " + _toDisplayString(_ctx.selectedMusicLabel), 1))
          : _createCommentVNode("", true),
        _createVNode("i", {
          class: ["fas ms-auto", _ctx.musicExpanded ? 'fa-chevron-up' : 'fa-chevron-down']
        }, null, 2)
      ]),
      _withDirectives(_createVNode("div", _hoisted_29, [
        _createVNode("label", _hoisted_30, [
          _withDirectives(_createVNode("input", {
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.musicTrackId = $event)),
            type: "radio",
            name: "fillMusic",
            value: null,
            disabled: _ctx.submitting
          }, null, 8, ["disabled"]), [
            [_vModelRadio, _ctx.musicTrackId]
          ]),
          _hoisted_31
        ]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.musicTracks, (track) => {
          return (_openBlock(), _createBlock("label", {
            key: track.id,
            class: "social-post-page__reel-tone-option"
          }, [
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.musicTrackId = $event)),
              type: "radio",
              name: "fillMusic",
              value: track.id,
              disabled: _ctx.submitting
            }, null, 8, ["value", "disabled"]), [
              [_vModelRadio, _ctx.musicTrackId]
            ]),
            _createVNode("span", _hoisted_32, [
              _createVNode("span", _hoisted_33, [
                _createTextVNode(_toDisplayString(track.title || `Track ${track.id}`) + " ", 1),
                (track.previewUrl)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-link btn-sm p-0 ms-2 align-baseline",
                      disabled: _ctx.submitting,
                      onClick: _withModifiers(($event: any) => (_ctx.playMusicPreview(track)), ["stop","prevent"])
                    }, " Preview ", 8, ["disabled", "onClick"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        }), 128))
      ], 512), [
        [_vShow, _ctx.musicExpanded]
      ]),
      _createVNode("button", {
        type: "button",
        class: "social-post-page__reel-section-header mb-2 w-100",
        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.captionExpanded = !_ctx.captionExpanded))
      }, [
        _hoisted_34,
        (!_ctx.captionExpanded)
          ? (_openBlock(), _createBlock("span", _hoisted_35, "· " + _toDisplayString(_ctx.selectedCaptionStyleLabel), 1))
          : _createCommentVNode("", true),
        _createVNode("i", {
          class: ["fas ms-auto", _ctx.captionExpanded ? 'fa-chevron-up' : 'fa-chevron-down']
        }, null, 2)
      ]),
      _withDirectives(_createVNode("div", _hoisted_36, [
        _hoisted_37,
        _createVNode("div", _hoisted_38, [
          _createVNode("span", {
            class: ["social-post-page__caption-preview-text", _ctx.captionStylePreviewClasses]
          }, _toDisplayString(_ctx.captionStylePreviewText), 3)
        ]),
        _createVNode("div", _hoisted_39, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.captionPresets, (preset) => {
            return (_openBlock(), _createBlock("label", {
              key: preset.id,
              class: "social-post-page__caption-swatch-option",
              title: preset.label
            }, [
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": ($event: any) => (_ctx.reelCaptionStyle.preset = $event),
                type: "radio",
                name: "fillCaptionPreset",
                value: preset.id,
                disabled: _ctx.submitting
              }, null, 8, ["onUpdate:modelValue", "value", "disabled"]), [
                [_vModelRadio, _ctx.reelCaptionStyle.preset]
              ]),
              _createVNode("span", {
                class: ["social-post-page__caption-swatch", preset.swatchClass]
              }, [
                _hoisted_40
              ], 2),
              _createVNode("span", _hoisted_41, _toDisplayString(preset.label), 1)
            ], 8, ["title"]))
          }), 128))
        ]),
        _hoisted_42,
        _createVNode("div", _hoisted_43, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.captionSizeOptions, (option) => {
            return (_openBlock(), _createBlock("label", {
              key: option.id,
              class: "social-post-page__radio-option"
            }, [
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.reelCaptionStyle.size = $event)),
                type: "radio",
                name: "fillCaptionSize",
                value: option.id,
                disabled: _ctx.submitting
              }, null, 8, ["value", "disabled"]), [
                [_vModelRadio, _ctx.reelCaptionStyle.size]
              ]),
              _createVNode("span", null, _toDisplayString(option.label), 1)
            ]))
          }), 128))
        ]),
        _hoisted_44,
        _createVNode("div", _hoisted_45, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.captionPositionOptions, (option) => {
            return (_openBlock(), _createBlock("label", {
              key: option.id,
              class: "social-post-page__radio-option"
            }, [
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.reelCaptionStyle.position = $event)),
                type: "radio",
                name: "fillCaptionPosition",
                value: option.id,
                disabled: _ctx.submitting
              }, null, 8, ["value", "disabled"]), [
                [_vModelRadio, _ctx.reelCaptionStyle.position]
              ]),
              _createVNode("span", null, _toDisplayString(option.label), 1)
            ]))
          }), 128))
        ]),
        _hoisted_46,
        _createVNode("div", _hoisted_47, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.captionCasingOptions, (option) => {
            return (_openBlock(), _createBlock("label", {
              key: option.id,
              class: "social-post-page__radio-option"
            }, [
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.reelCaptionStyle.casing = $event)),
                type: "radio",
                name: "fillCaptionCasing",
                value: option.id,
                disabled: _ctx.submitting
              }, null, 8, ["value", "disabled"]), [
                [_vModelRadio, _ctx.reelCaptionStyle.casing]
              ]),
              _createVNode("span", null, _toDisplayString(option.label), 1)
            ]))
          }), 128))
        ])
      ], 512), [
        [_vShow, _ctx.captionExpanded]
      ]),
      _createVNode("div", _hoisted_48, [
        _createVNode("label", _hoisted_49, [
          _withDirectives(_createVNode("input", {
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.autoPublish = $event)),
            type: "checkbox",
            class: "mt-1",
            disabled: _ctx.submitting
          }, null, 8, ["disabled"]), [
            [_vModelCheckbox, _ctx.autoPublish]
          ]),
          _hoisted_50
        ])
      ]),
      (_ctx.formError)
        ? (_openBlock(), _createBlock("p", _hoisted_51, _toDisplayString(_ctx.formError), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "onClosed"]))
})